import React from "react";
import { Outlet } from "react-router-dom";
import { Card } from "react-bootstrap";

import styles from "styles/auth/auth.module.css";
import "global-in.css";

const Auth = () => {
  return (
    <div className={styles.loginContainer}>
      <div className={styles.loginField}>
        <div className={styles.rows}>
          <div className={styles.row1}>
            <img src="/BA_assets-09.png" />
          </div>
          <div className={styles.row2}>
            <img src="/BA_assets-10.png" />
          </div>
          <div className={styles.row3}>
            <div className={styles.row3Col}>
              <img src="/BA_assets-08.png" />
            </div>
            <div className={styles.row3Col}>
              {" "}
              <Outlet />
            </div>
            <div className={styles.row3Col}></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Auth;
